module.exports = __webpack_public_path__ + "static/media/user-bg.803b275c.png";